(function() {
    'use strict';
    
a3_cabin_reports.controller('OpenReportDialogCtrl', OpenReportDialogCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name OpenReportDialogCtrl
    * @description 
    *  Manages the open report modal functionality 
    * @ngInject
    */
function OpenReportDialogCtrl($scope, $uibModalInstance, $location, apiUrl, UserFactory, FlightFactory, CabinReportLocalEditFactory, flightId) {

		var user = UserFactory.getUser();
		var allServerReports = [];
		var flight = FlightFactory.getFlightFromStorage(flightId);

		if (flight == null)
			return;

		// load the reports
		var serverReportForThisUser = flight.getServerCabinReportForUser(user.aimsId);
		var serverReportsByAnotherUser = flight.getServerCabinReportsByAnotherUser(user.aimsId);
		var localReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);

		// the user can create a new report only if there is not an existing one and
		// there is not a server report by him
		if ((localReport != null) || (serverReportForThisUser != null))
			$scope.canCreateNewLocalReport = false;
		else
			$scope.canCreateNewLocalReport = true;

		if (serverReportForThisUser != null) {
			serverReportForThisUser.IsSameUser = " (YOU)";
			allServerReports.push(serverReportForThisUser);
		}

		for (var i = 0; i < serverReportsByAnotherUser.length; i++)
			allServerReports.push(serverReportsByAnotherUser[i]);

		$scope.localReport = localReport;
		$scope.serverReports = allServerReports;

		$scope.cancel = cancel;
        $scope.createNewLocalReport = createNewLocalReport;
        $scope.openLocalReport = openLocalReport;
        $scope.openServerReport = openServerReport;

        /**
         * Close Modal
         * @memberof OpenReportDialogCtrl
         */
        function cancel() {
			$uibModalInstance.dismiss('');
		}
  
        /**
         * Create new report and close modal
         * @memberof OpenReportDialogCtrl
         */
        function createNewLocalReport() {
			$location.path("report/new:" + -1 + "/" + flightId);
			$uibModalInstance.dismiss('');
		}
    
        /**
         * Open Local Report
         * @memberof OpenReportDialogCtrl
         * @param {object} report
         */
        function openLocalReport(report) {
			$location.path("report/" + report.ReportGuid);
			$uibModalInstance.dismiss('');
		}

        /**
         * Open Server stored Report
         * @memberof OpenReportDialogCtrl
         * @param {object} report
         */
        function openServerReport(report) {
			// get user token and send it as a parameter on the call
			var token = '';
			if (user != null) {
				token = user.token;
				token = encodeURIComponent(token);

				$location.path("reportsHistory/" + report.ReportId  + "/" + flightId+"/Cabin");

			}
			$uibModalInstance.dismiss('');
		}

	}

})();